<template>
  <article class="form-container">
    <Title class="title">{{
      $t('account_deletion.delete_account_title')
    }}</Title>

    <p class="description" v-if="!success">
      {{ $t('account_deletion.request_description') }}
    </p>
    <form v-on:submit.prevent v-if="!success">
      <input
        placeholder="E-Mail"
        id="email"
        name="email"
        @input="onEmailChange"
        rows="4"
        cols="50"
        class="email_input"
        v-model="email"
      />
      <button
        :class="{
          'feedback-btn-disabled': !enableButton,
          'feedback-btn': enableButton,
        }"
        @click="handleFormSubmit"
        :disabled="!enableButton"
      >
        {{ $t('account_deletion.submit') }}
      </button>

      <div class="error-message" v-if="error">
        {{ errorMessage }}
      </div>
    </form>
    <div class="successfull-container" v-if="success">
      <img src="~@/assets/success_ic.svg" class="successfull-icon" />
      <p class="successfull-title">
        {{ $t('account_deletion.request_successfull_message') }}
      </p>
      <p class="sucessfull-text">
        {{ $t('account_deletion.email_confirm_message') }}
      </p>
    </div>
  </article>
</template>
<script>
import Title from './Title.vue';

import {
  getRecaptchaToken,
  loadGoogleCaptcha,
  unloadGoogleCaptcha,
} from '../../shared/recaptchaHelper';

import i18n from '../../i18n';

import EmailUtils from '../../shared/email';

export default {
  components: { Title },
  mounted() {
    loadGoogleCaptcha();
  },
  beforeDestroy() {
    unloadGoogleCaptcha();
  },
  data() {
    return {
      email: '',
      error: false,
      success: false,
      enableButton: false,
      errorMessage: '',
    };
  },
  methods: {
    async handleFormSubmit() {
      if (!EmailUtils.emailIsValid(this.email)) {
        this.error = true;
        this.errorMessage = i18n.t('signup.input_email_error');
        return;
      }

      const recaptchaToken = await getRecaptchaToken('REQUEST_DELETION');

      const formData = new URLSearchParams();

      formData.append('email', this.email);

      try {
        const result = await fetch(
          `${process.env.VUE_APP_USER_SERVICE_URL}/user/request-deletion`,
          {
            method: 'POST',
            body: formData,
            headers: {
              accept: 'application/json',
              'Content-Type': 'application/x-www-form-urlencoded',
              'recaptcha-token': recaptchaToken,
            },
          }
        );

        if (result.ok) {
          this.error = false;
          this.success = true;
        } else {
          this.error = true;
          this.success = false;
          this.errorMessage = i18n.t('contact.unknown_error');
        }
      } catch (error) {
        this.error = true;
        this.success = false;
        this.errorMessage = i18n.t('contact.unknown_error');
      }

      this.updateState();
    },

    onEmailChange() {
      this.error = false;
      this.success = false;
      this.errorMessage = '';
      this.updateState();
    },
    updateState() {
      this.enableButton = !this.success && this.email.length > 0;
    },
  },
};
</script>

<style>
.success-message {
  margin-top: 40px;
  border-radius: 5px;
  border: 1px solid;
  border-color: #70d38c;
  background-color: #70d38c1a;
  color: #70d38c;
  padding: 20px;
}

.error-message {
  margin-top: 0.6em;
  position: relative;
  border: 1px solid #f15c5e;
  padding: 1em 2em;
  border-radius: 12px;
  color: #f15c5e;
}

.title {
  margin-top: 30px;
}

.description {
  margin-top: 30px;
  margin-bottom: 20px;
  color: #2b4047;
}

.form-container {
  padding-left: 2rem;
  padding-right: 2rem;
}

.item {
  display: block;
  margin-top: 13px;
  margin-bottom: 13px;
}

.item input {
  margin-right: 20px;
}

.email_input {
  font-size: 14px;
  color: #2b4047;
  width: 100%;
  padding: 12px;
  border: 1px solid #ecf1f2;
  border-radius: 4px;
  outline: 0;
  box-shadow: 0px 1px 3px #00000029;
  margin-top: 10px;
  margin-bottom: 30px;
}

.feedback-btn {
  border-radius: 30px;
  width: 100%;
  height: 42px;
  opacity: 1;
  color: #2b4047;
  background: #ffdf22;
  box-shadow: 0px 3px 6px #00000029;
}

.feedback-btn-disabled {
  color: #2b4047;
  background: #ffdf22;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 30px;
  width: 100%;
  height: 42px;
  opacity: 1;
  opacity: 0.3;
}

.successfull-icon {
  display: inline;
}

.successfull-title {
  display: inline;
  color: #70d38c;
  font-size: 16px;
}

.sucessfull-text {
  font-size: 16px;
  margin: 10px 0 0 0;
  color: #2b4047;
}

.successfull-container {
  margin: 80px 0 0 0;
}

/*
  ======================
         DESKTOP
  ======================
  */

@media (min-width: 1024px) {
  .title {
    margin-top: 30px;
  }

  .description {
    margin-top: 30px;
    margin-bottom: 20px;
  }

  .form-container {
    padding-left: 15%;
    padding-right: 15%;
  }

  .item {
    display: block;
    margin-top: 13px;
    margin-bottom: 13px;
  }

  .item input {
    margin-right: 20px;
  }
}
</style>
